import {
  Card as MuiCard,
  Box,
  Typography as Typo,
  styled,
  TypographyProps,
  Link,
  Skeleton,
} from '@mui/material';
import SwitchWithHeading from '@jobseeker/lotus/components/SwitchWithHeading';
import {useDispatch, useSelector} from 'react-redux';
import {AppState} from '@jobseeker/common-core/types';
import {saveUserSettings} from '@jobseeker/common-core/reducers/user/thunkServices';
import {useIsLargeDevice} from '@jobseeker/lotus/hooks';
import {getOldLink} from '@jobseeker/lotus/utils';

const coverLetter = 'cover letter';
const settings = [
  {
    heading: 'Include Cover Letter while applying',
    description: (
      <>
        Your
        <Link
          href={getOldLink(`/registration/addCoverLetterAndSkills`)}
          sx={{
            color: 'var(--brand-color, #49966E)',
            textDecoration: 'none',
            padding: 0,
            margin: '0 4px 0 4px',
            fontSize: {xxs: 12, md: 14},
            display: 'inline-block',
            verticalAlign: 'baseline',
            '&:hover': {
              color: 'var(--brand-color, #49966E)',
              textDecoration: 'none',
            },
            '&:focus, &:active': {
              color: 'var(--brand-color, #49966E)',
              textDecoration: 'none',
            },
          }}
          onClick={(e: React.MouseEvent<HTMLAnchorElement>) => {
            e.stopPropagation();
          }}
        >
          {coverLetter}
        </Link>
        will be attached to each of your applications
      </>
    ),
    key: 'coverLetter',
  },
  {
    heading: 'Allow similar course enquiry',
    key: 'similarCourseEnquiry',

    description:
      'When you inquire about a course, your interest will also be communicated to providers offering similar courses',
  },
  // {
  //   heading: 'Show Review & Submit',
  //   descrption:
  //     'Review your application will be shown each time you apply to a job',
  // },
];

const Card = styled(MuiCard)(({theme}) => ({
  borderRadius: theme.spacing(2),
}));

const Typography = styled(Typo)<TypographyProps>(({}) => ({
  display: 'flex',
  alignItems: 'center',
}));

const OtherSettingWidget = (props: {loading: boolean}) => {
  const {loading} = props;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const dispatch: any = useDispatch();
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const userSettings: any = useSelector(
    (state: AppState) => state.user.profile.settings
  );
  const isLarge = useIsLargeDevice();
  const saveSettings = (name: string, value: number) => {
    dispatch(
      saveUserSettings({
        [name]: value == 1 ? 0 : 1,
      })
    );
  };
  return (
    <>
      <Card
        sx={{
          boxShadow: 2,
          borderRadius: 4,
          marginLeft: {md: 2},
        }}
      >
        <Box>
          {isLarge && (
            <Typography
              // component={injectAsChild ? 'p' : 'h1'}
              display="flex"
              fontSize={{xxs: 16, md: 20}}
              fontWeight={{xxs: 600, md: 500}}
              m={2}
              mb={1}
              mt={3}
              sx={{
                wordWrap: 'break-word',
                textTransform: 'capitalize',
              }}
            >
              Others
            </Typography>
          )}
          <Box
            mt={isLarge ? 0 : 3}
            sx={{
              '& > .notification-list-box:last-child .notification_list_item': {
                border: 'unset',
              },
            }}
          >
            {settings.map((ele, index) => {
              return (
                <>
                  {loading ? (
                    <Box
                      display={'flex'}
                      justifyContent={'space-between'}
                      px={1}
                      mb={3}
                    >
                      <Box width={'100%'}>
                        <Skeleton
                          variant="rounded"
                          width={'50%'}
                          height={16}
                          sx={{my: 1}}
                        />
                        <Skeleton
                          variant="rounded"
                          width={'30%'}
                          height={12}
                          sx={{my: 1}}
                        />
                      </Box>
                      <Skeleton
                        variant="rounded"
                        width={100}
                        height={25}
                        sx={{
                          my: 1,
                        }}
                      />
                    </Box>
                  ) : (
                    <Box
                      key={`setting-switch-${index}`}
                      onClick={() =>
                        saveSettings(ele.key, userSettings[ele.key])
                      }
                      className="notification-list-box"
                    >
                      <SwitchWithHeading
                        heading={ele.heading}
                        description={ele.description}
                        value={!!userSettings[ele.key]}
                        customBottomMargin={15.25}
                        isLastItem={index === settings.length - 1}
                      />
                    </Box>
                  )}
                </>
              );
            })}
          </Box>
        </Box>
      </Card>
    </>
  );
};

export default OtherSettingWidget;
